module.exports = __webpack_public_path__ + "img/sketch-logo-light.2f58943a.svg";